import React from 'react'
import { Stack, Table, TableBody, Grid, TableCell, TableContainer, TableHead, TableRow, Box, Button, Tooltip, Paper, paperClasses } from '@mui/material'
import moment from 'moment/moment'
import { getPaymentTypeBackground } from '../../../common/helper'

const DispatchMiddSection4 = ({
  tableData,
  loginData,
  reportType,
  showSummaryReport,
  detailedFilter,
  selFromBranch,
  selDestCity,
  selBranch,
  toDate,
  fromDate,
  selVehicle,
  selPaymentTpe,
  paymentSummary,
  paymentWiseVehicleData,
}) => {
  const InsideRowContentSummary = ({ item, index,itSelfArray,fontVal}) => {
    return (
      <>
        <TableRow>
          <>
            <TableCell
              className="reportTD"
              colSpan={2}
              style={{
                fontWeight:itSelfArray.length-1==index?'bold':'',
                backgroundColor:itSelfArray.length-1==index?'#EEE':'',
                fontSize: fontVal,
                textAlign: 'left',
                whiteSpace: 'nowrap',
              }}
            >
              {item.vehicleNo}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item.paidQuantity}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item.paidAmount}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item.toPayQuantity}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item.toPayAmount}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item.fOCQuantity}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item.fOCAmount}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item.cODQuantity}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item.cODAmount}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item.onAccountQuantity}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item.onAccountAmount}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item['paid(Manual)Quantity']}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item['paid(Manual)Amount']}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item['toPay(Manual)Quantity']}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item['toPay(Manual)Amount']}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item.selfQuantity}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item.selfAmount}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item['onAccount(Manual)Quantity']}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item['onAccount(Manual)Amount']}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item.totalUnits}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight:itSelfArray.length-1==index?'bold':'', textAlign: 'right',backgroundColor:itSelfArray.length-1==index?'#EEE':'' }}
            >
              {item.totalAmount}
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }
  const TableRowData = ({ item,fontVal }) => {
    return (
      <>
        <TableRow>
          <TableCell
            className="reportTD"
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'left',
              whiteSpace: 'nowrap',
              verticalAlign:'top'
            }}
          >
            {item.OnlyLRNo}&nbsp;
          </TableCell>
          <TableCell
            className="reportTD"
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'left',
              whiteSpace: 'nowrap',
              verticalAlign:'top',
            }}
          >
            {item.SenderName}
          </TableCell>
          <TableCell
            className="reportTD"
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'left',
              whiteSpace: 'nowrap',
              verticalAlign:'top',
            }}
          >
            {item.SenderGSTN}
          </TableCell>
          <TableCell
            className="reportTD"
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'left',
              whiteSpace: 'nowrap',
              verticalAlign:'top',
            }}
          >
            {item.RecName}
          </TableCell>
          <TableCell
            className="reportTD"
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'left',
              whiteSpace: 'nowrap',
              verticalAlign:'top',
            }}
          >
            {item.ReceiverGSTN}
          </TableCell>
          <TableCell
            className="reportTD"
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'right',
              whiteSpace: 'nowrap',
              verticalAlign:'top',
            }}
          >
            {item.Quantity}
          </TableCell>
          <TableCell
            className="reportTD"
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'left',
              whiteSpace: 'nowrap',
              verticalAlign:'top',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '150px',
            }}
          >
            <Tooltip title={item.ItemDetails} placement="top-start">
             <span>{item.ItemDetails}</span>
            </Tooltip>
          </TableCell>
          <TableCell className="reportTD" colSpan={1}>
            <span
              style={{
                // justifyContent: 'center',
                display: 'flex',
                padding: '4px 8px',
                alignItems: 'center',
                gap: '10px',
                whiteSpace: 'nowrap',
                verticalAlign:'top',
                padding: '4px 10px',
                fontWeight: 'bold',
                background: 'F5FAFE',
                fontSize: fontVal,
                fontWeight: '500',
                color: 'black',
                borderRadius: '13px',
                textAlign: 'left',
                backgroundColor: getPaymentTypeBackground(item.PaymentType),
              }}
            >
              {item.PaymentType}
            </span>
          </TableCell>
          <TableCell
            className="reportTD"
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'right',
              whiteSpace: 'nowrap',
              verticalAlign:'top',
            }}
          >
            {item.NetAmount}
          </TableCell>
          <TableCell
            className="reportTD"
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'left',
              whiteSpace: 'nowrap',
              verticalAlign:'top',
            }}
          >
            {item.Remarks}
          </TableCell>
        </TableRow>
      </>
    )
  }
  const getTable = (e,fontVal) => {
    return (
      <>
        {Object.keys(e).length === 1 ? (
          <TableRow>
            <TableCell
              className="receivedTD"
              style={{
                fontWeight: 'bold',
                background: 'rgb(241, 249, 255)',
                fontSize: fontVal,
                fontWeight: '500',
                textAlign: 'left',
                whiteSpace: 'nowrap',
                borderbottom: '1px solid rgba(0, 0, 0, 0.10)',
                height:'36px'
              }}
              colSpan={10}
            >
              {`${e.LRNO}`}
            </TableCell>
          </TableRow>
        ) : Object.keys(e).length === 4 ? (
          <TableRow>
            <TableCell
              className="receivedTD"
              style={{
                fontWeight: 'bold',
                backgroundColor:'#EEE',
                fontSize: fontVal,
                fontWeight: '700',
                textAlign: 'right',
                whiteSpace: 'nowrap',
                borderbottom: '1px solid rgba(0, 0, 0, 0.10)',
                height:'36px'
              }}
              colSpan={5}
            >
              {`${e.LRNO}`}
            </TableCell>
            <TableCell
              className="receivedTD"
              style={{
                fontWeight: 'bold',
                 backgroundColor:'#EEE',
                fontSize: fontVal,
                fontWeight: '700',
                textAlign: 'right',
                whiteSpace: 'nowrap',
                borderbottom: '1px solid rgba(0, 0, 0, 0.10)',
              }}
              colSpan={1}
            >
              {`${e.Quantity}`}
            </TableCell>
            <TableCell
              className="receivedTD"
              style={{
                fontWeight: 'bold',
                 backgroundColor:'#EEE',
                fontSize: fontVal,
                fontWeight: '700',
                textAlign: 'right',
                whiteSpace: 'nowrap',
                borderbottom: '1px solid rgba(0, 0, 0, 0.10)',
              }}
              colSpan={3}
            >
              {e.NetAmount}
            </TableCell>
            <TableCell
              className="receivedTD"
              style={{
                fontWeight: 'bold',
                backgroundColor:'#EEE',
                fontSize: fontVal,
                fontWeight: '700',
                textAlign: 'right',
                whiteSpace: 'nowrap',
                borderbottom: '1px solid rgba(0, 0, 0, 0.10)',
              }}
              colSpan={1}
            ></TableCell>
          </TableRow>
        ) : (
          <TableRowData item={e} fontVal={fontVal} />
        )}
      </>
    )
  }

  return (
    <>
      <Stack sx={{ marginLeft: 2, marginRight: 2, height: 480, paddingTop: '10px' }} >
        <TableContainer className="scrollBlue" sx={{"&::-webkit-scrollbar": {width:'6px',height:'6px'},border:'1px solid #aeaeae','& .MuiTableCell-root': {
            fontSize: '14px !important'
        }}} component={Paper}>
          <Table >
          <Table style={{minWidth:'100%'}}  className="table1 table-Report" size="small" aria-label="a dense table" >
            <TableHead style={{ position: 'sticky', top: '0' }}>
              <TableRow style={{ backgroundColor: '#bfe1ff', color: '#444444' }}>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '14px', fontWeight: '700', textAlign: 'left', color: '#444444',height:'36px' }}
                  colSpan={3}
                >
                  Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '14px', fontWeight: '700', textAlign: 'center', color: '#444444',height:'36px' }}
                  colSpan={3}
                >
                  Destination City: {selDestCity?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '14px', fontWeight: '700', textAlign: 'right', color: '#444444',height:'36px' }}
                  colSpan={4}
                >
                  Destination Branch: {selBranch?.name}
                </TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                    height:'36px'
                  }}
                  colSpan={1}
                >
                  LR NO.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Sender Name
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Sender GSTIN
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Receiver Name
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Receiver GSTIN
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  No. of Parcels
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Goods Description
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Payment Type
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Total Amount
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Remarks
                </TableCell>
              </TableRow>
            </TableHead>
            {paymentSummary?.map((e) => getTable(e,'12px'))}
          </Table>
          <Table 
            sx={{ marginRight: 2, paddingTop: '10px', marginTop: '30px'}}
            id="table1"
            className="table1 table-Report"
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ position: 'sticky', top: '0' }}>
              <TableRow>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'center',
                    borderRight:'1px solid rgb(224,224,224,1)'
                  }}
                  colSpan={2}
                  rowSpan={2}
                >
                  Vehicle Number
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={2}
                >
                  Paid
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'center',
                  }}
                  colSpan={2}
                >
                  ToPay
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'center',
                  }}
                  colSpan={2}
                >
                  FOC
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'center',
                  }}
                  colSpan={2}
                >
                  COD
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={2}
                >
                  On Account
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'center',
                  }}
                  colSpan={2}
                >
                  Paid(Manual)
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={2}
                >
                  To Pay(Manual)
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={2}
                >
                  Self Booking
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={2}
                >
                  On Account(Manual)
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'center',
                  }}
                  colSpan={2}
                >
                  Total
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Total Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Total Amount
                </TableCell>
              </TableRow>
            </TableHead>
            {paymentWiseVehicleData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={22}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '14px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : paymentWiseVehicleData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{ textAlign: 'center', fontSize: '14px', fontWeight: '500', marginLeft: '5px' }}
              >
                {paymentWiseVehicleData?.map((item, index,itSelfArray) => (
                  <InsideRowContentSummary item={item} index={index} key={index} itSelfArray={itSelfArray} fontVal={'12px'}/>
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
          </Table>
          <Table style={{display:'none'}} id="tables">
          <Table style={{minWidth:'100%'}}  className="table1 table-Report" size="small" aria-label="a dense table" >
            <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={5}
                >
                  <h3 style={{ paddingLeft: '17px' }}>Report For: Dispatch Report -</h3>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'right' }}
                  colSpan={5}
                >
                  <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData.strCompanyName}</h3>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={10}></TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  From Dispatch Date
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  To Dispatch Date
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  dispatch By Branch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Destination City
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  DestinationBranch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Vehicle Number
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Payment Type
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Report Type
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Report View
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Report Option
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{moment(fromDate).format('MM/DD/YYYY')}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{moment(toDate).format('MM/DD/YYYY')}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{selFromBranch?.name || loginData?.strBranchName}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{selDestCity?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{selBranch?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{selVehicle?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{selPaymentTpe?.name || 'All'}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{reportType?.Name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{showSummaryReport?.Name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{detailedFilter?.Name} </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={10}></TableCell>
              </TableRow>
            </TableHead>
            <TableHead style={{ position: 'sticky', top: '0' }}>
              <TableRow style={{ backgroundColor: '#bfe1ff', color: '#444444' }}>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '20px', fontWeight: '700', textAlign: 'left', color: '#444444',height:'36px' }}
                  colSpan={3}
                >
                  Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '20px', fontWeight: '700', textAlign: 'center', color: '#444444',height:'36px' }}
                  colSpan={3}
                >
                  Destination City: {selDestCity?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '20px', fontWeight: '700', textAlign: 'right', color: '#444444',height:'36px' }}
                  colSpan={4}
                >
                  Destination Branch: {selBranch?.name}
                </TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    height:'36px'
                  }}
                  colSpan={1}
                >
                  LR NO.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Sender Name
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Sender GSTIN
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Receiver Name
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Receiver GSTIN
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  No. of Parcels
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Goods Description
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Payment Type
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Total Amount
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Remarks
                </TableCell>
              </TableRow>
            </TableHead>
            {paymentSummary?.map((e) => getTable(e,'20px'))}
          </Table>
          <Table 
            style={{ marginRight: 2, paddingTop: '10px', marginTop: '30px'}}
            id="table1"
            className="table1 table-Report"
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ position: 'sticky', top: '0' }}>
              <TableRow>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight:'1px solid rgb(224,224,224,1)'
                  }}
                  colSpan={2}
                  rowSpan={2}
                >
                  Vehicle Number
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={2}
                >
                  Paid
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'center',
                  }}
                  colSpan={2}
                >
                  ToPay
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'center',
                  }}
                  colSpan={2}
                >
                  FOC
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'center',
                  }}
                  colSpan={2}
                >
                  COD
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={2}
                >
                  On Account
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'center',
                  }}
                  colSpan={2}
                >
                  Paid(Manual)
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={2}
                >
                  To Pay(Manual)
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={2}
                >
                  Self Booking
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={2}
                >
                  On Account(Manual)
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'center',
                  }}
                  colSpan={2}
                >
                  Total
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Total Units
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Total Amount
                </TableCell>
              </TableRow>
            </TableHead>
            {paymentWiseVehicleData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={22}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '20px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : paymentWiseVehicleData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{ textAlign: 'center', fontSize: '20px', fontWeight: '500', marginLeft: '5px' }}
              >
                {paymentWiseVehicleData?.map((item, index,itSelfArray) => (
                  <InsideRowContentSummary item={item} index={index} key={index} itSelfArray={itSelfArray} fontVal={'20px'}/>
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
          </Table>
        </TableContainer>
      </Stack>
    </>
  )
}

export default DispatchMiddSection4
